import { createSlice } from "@reduxjs/toolkit";
const initialWorkScheduleState = { workScheduleData: [] };

export const workScheduleSlice = createSlice({
  name: "workSchedule",
  initialState: initialWorkScheduleState,
  reducers: {
    setWorkScheduleState(state, action) {
      state.workScheduleData = [...state.workScheduleData, ...action.payload ];
    },
    resetWorkScheduleState(state) {
     return initialWorkScheduleState;
    },
    updateWorkScheduleState(state, action) {
      state.workScheduleData = [...state.workScheduleData, ...action.payload ];
    },
  },
});